// extracted by mini-css-extract-plugin
export default {"editWatermarkForm":"watermarks_editWatermarkForm__BsvjU","editWatermarkFormFields":"watermarks_editWatermarkFormFields__7UCQq","previewButton":"watermarks_previewButton__H4Lgs"};